import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { extractAuthCode, generateToken } from '../services/fyersAuth';

function FyersCallbackPage() {
  const navigate = useNavigate();
  const { api } = useAppContext();
  const hasProcessedRef = useRef(false);
  const [status, setStatus] = useState('Processing Fyers login...');
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessedRef.current) {
      return;
    }

    hasProcessedRef.current = true;

    const processAuth = async () => {
      try {
        const authCode = extractAuthCode();

        if (!authCode) {
          throw new Error('Auth code missing in callback URL');
        }

        setStatus('Validating Fyers auth code...');
        const tokenResponse = await generateToken(authCode);
        const token = tokenResponse.access_token;
        const { pin, appIDHash, clientID } = tokenResponse;

        if (!token) {
          throw new Error(tokenResponse.message || tokenResponse.messsage || 'Fyers access token missing');
        }

        setStatus('Saving Fyers token...');
        await api.updateRefreshToken(token, pin, appIDHash, clientID);
        setStatus('Redirecting to dashboard...');
        navigate('/', { replace: true });
      } catch (caughtError) {
        setError(caughtError.message || 'Fyers login failed');
        setStatus('Fyers login failed.');
      }
    };

    processAuth();
  }, [api, navigate]);

  return (
    <div className="login-shell">
      <div className="login-panel" style={{ gridTemplateColumns: '1fr' }}>
        <div className="login-card" style={{ maxWidth: '560px', margin: '0 auto' }}>
          <p className="eyebrow">Broker Authentication</p>
          <h2>{status}</h2>
          <p className="supporting-text dark-text">
            Please wait while the admin dashboard finishes the Fyers authorization flow.
          </p>
          {error ? (
            <div
              style={{
                padding: '14px 16px',
                borderRadius: '14px',
                background: 'var(--danger-soft)',
                color: 'var(--danger)'
              }}
            >
              {error}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default FyersCallbackPage;
